/** @jsx h */
import { h, Component } from 'preact';
import requestService from '../../api/services/requestService';
import { apiStatus } from '../../actionTypes';
import { removeBlankKeys } from '../../components/material-ui/helper';
import { connect } from 'react-redux';
import widgetAction from '../../actions/widgetAction';
import actionType from '../../actions/widgetAction/actionType';
import {
  initializeTracker,
  PageLoadType,
  tracker,
  UserActionType,
} from '../../tracking';
import {
  fetchWidgetConfig,
  fetchUserEligibleEMI,
} from '../../api/controllers/widgetControllers';
import Utils, { getLocalstorage } from '../../utils';
import { CLIENT_ID_COOKIE_KEY } from '../../tracking/helper';
import {
  experimentName,
  fetchExperimentData,
} from '../../api/controllers/experimentController';
import {
  getValidParentMerchantUrl,
  isParentMerchantOriginValid,
} from '../../utils/merchantOriginHelper';
import { PRODUCT_WIDGET_AUTH_HEADER_NAME } from '../../constants';

class WidgetCommunicationScreen extends Component {
  componentDidMount() {
    window.addEventListener('message', this.handleIframeTask);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeTask);
  }

  handleIframeTask = (e) => {
    const isWrongDataBeingPassed =
      typeof e.data === 'object' ? true : !e.data.includes('dataType');

    const postMessageOrigin = e.origin;

    if (
      postMessageOrigin === window.location.origin &&
      typeof e.data !== 'object' &&
      e.data.includes('isTerminalState')
    ) {
      this.sendDataToParents({
        responseType: 'ntbResponse',
        response: {
          isTerminalState: JSON.parse(e.data).isTerminalState === true,
        },
      });
    }

    if (
      e.data === '' ||
      e.target.name !== 'instacred' ||
      isWrongDataBeingPassed
    ) {
      return;
    }

    if (!isParentMerchantOriginValid(postMessageOrigin)) {
      console.log('Parent merchant url is not valid');
      return;
    }

    try {
      JSON.parse(e.data);
    } catch (err) {
      throw `${err}: ${
        e.data.includes('dataType') ? 'Invalid InstaCred response' : e.data
      } ${postMessageOrigin} ${window.location.origin}`;
    }

    const { dataType, requestName, request, merchantKey, icScope } =
      JSON.parse(e.data) || {};

    icScope === 'eligibility-sdk'
      ? initializeTracker()
      : initializeTracker(null, true);

    if (dataType === 'tracking') {
      const { eventType, trackingData } = request || {};
      switch (eventType) {
        case 'pageView': {
          const { pageKey, metadata } = trackingData || {};
          return tracker.trackPageView(PageLoadType.DYNAMIC, pageKey, metadata);
        }
        case 'userAction': {
          const { elementName, pageKey, metadata } = trackingData || {};
          return tracker.trackUserInteraction(
            UserActionType.CLICK,
            elementName,
            pageKey,
            metadata,
          );
        }
        default:
          return null;
      }
    }
    if (dataType === 'apiType') {
      const headers = {
        'ic-merchant-key': merchantKey,
        'ic-origin': postMessageOrigin,
        'ic-merchant-sdk-scope': icScope,
      };
      this.props.widgetAction(actionType.storeHeader, headers);
      /**
       * If else condition Added to make sure that previous version will also support the communication
       * TODO: Remove the else condition after caching related
       * issue won't be there and also remove `this.getData` methods
       */
      if (requestName) {
        this.handleAPIRequest(
          requestName,
          request,
          { headers },
          postMessageOrigin,
        );
      } else {
        this.sendDataToParents(
          {
            responseType: 'apiResponse',
            apiStatus: apiStatus.INITIATED,
            response: {},
          },
          postMessageOrigin,
        );
        this.getData(null, removeBlankKeys(request), { headers })
          .then((resp) => {
            this.sendDataToParents(
              {
                responseType: 'apiResponse',
                apiStatus: apiStatus.SUCCESS,
                response: resp,
              },
              postMessageOrigin,
            );
          })
          .catch((error) => {
            this.sendDataToParents(
              {
                responseType: 'apiResponse',
                apiStatus: apiStatus.ERROR,
                response: error,
              },
              postMessageOrigin,
            );
          });
      }
    }
  };

  handleAPIRequest = (requestName, requestData, header, postMessageOrigin) => {
    this.sendDataToParents(
      {
        requestName,
        responseType: 'apiResponse',
        apiStatus: apiStatus.INITIATED,
        response: {},
      },
      postMessageOrigin,
    );
    switch (requestName) {
      case 'fetchWidgetConfig':
        return fetchWidgetConfig(header)
          .then((resp) => {
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.SUCCESS,
                response: resp,
              },
              postMessageOrigin,
            );
          })
          .catch((error) => {
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.ERROR,
                response: error,
              },
              postMessageOrigin,
            );
          });

      case 'checkUserEligibility':
        const {
          mobile,
          amount,
          isCardEmiEnabled,
          productWidgetHeader,
        } = requestData;
        if (header && header.headers && productWidgetHeader) {
          header.headers[PRODUCT_WIDGET_AUTH_HEADER_NAME] = productWidgetHeader;
        }
        let cookieDisabled = false;
        try {
          if (!navigator.cookieEnabled) {
            cookieDisabled = true;
          }
        } catch (e) {}

        return fetchUserEligibleEMI(
          { mobile, amount, isCardEmiEnabled },
          null,
          header,
        )
          .then((resp) => {
            if (resp && resp.data && resp.data.mobile) {
              //creating a profile for user
              tracker.pushUserProfile();
            }

            const { responseICHeaders } = resp.data || {};
            const productWidgetHeader =
              responseICHeaders &&
              responseICHeaders[PRODUCT_WIDGET_AUTH_HEADER_NAME];
            if (productWidgetHeader) {
              delete resp.data.responseICHeaders;
              if (productWidgetHeader) {
                resp.data.productWidgetHeader = productWidgetHeader;
              }
            }
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.SUCCESS,
                response: resp,
              },
              postMessageOrigin,
            );
          })
          .catch((error) => {
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.ERROR,
                response: error,
              },
              postMessageOrigin,
            );
          });
      case 'widgetNonLoggedInExperiment':
        const clientId =
          Utils.getCookie(CLIENT_ID_COOKIE_KEY) ||
          getLocalstorage(CLIENT_ID_COOKIE_KEY);
        const data = {
          experimentName: experimentName.WIDGET_NL_VARIANT,
          uniqueId: clientId,
        };
        return fetchExperimentData(data, null, header)
          .then((resp) => {
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.SUCCESS,
                response: resp,
                experimentName: experimentName.WIDGET_NL_VARIANT,
              },
              postMessageOrigin,
            );
          })
          .catch(() => {
            this.sendDataToParents(
              {
                requestName,
                responseType: 'apiResponse',
                apiStatus: apiStatus.SUCCESS,
                response: { data: { value: 'A' } }, //making sure in case of error we are getting 'A' variant only
                experimentName: experimentName.WIDGET_NL_VARIANT,
              },
              postMessageOrigin,
            );
          });
      default:
        return null;
    }
  };

  sendDataToParents = (data = {}, postMessageOrigin) => {
    const validParentMerchantUrl = getValidParentMerchantUrl(postMessageOrigin);
    window.parent.postMessage(JSON.stringify(data), validParentMerchantUrl);
  };

  getData = (query, request, header) => {
    return requestService(query, request, (d) => d.data, null, null, header);
  };

  render() {
    return null;
  }
}

export default connect(
  null,
  { widgetAction },
)(WidgetCommunicationScreen);



// WEBPACK FOOTER //
// ./routes/widget-communication-screen/index.js